export default {
  development: 'http://localhost:3080',
  // Mismo artefacto para Gamma, Showcase y futuras instancias: el backend
  // siempre se resuelve en el mismo origen desde el que se sirve el frontend.
  production: `${window.location.origin}/backend`,
};
